import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import ja from './ja.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import tr from './tr.json';
import tw from './tw.json';
import vi from './vi.json';
import zh from './zh.json';

export default {
  de,
  en,
  es,
  fr,
  ja,
  ko,
  pt,
  ru,
  tr,
  tw,
  vi,
  zh
};
